import { cn } from "./utils";

/**
 * Work in progress. A ring rather than a label, because it sits inside badges and table
 * cells where there is room for a glyph and nothing more. Reduced motion stops the
 * rotation and leaves the open ring, which still reads as unfinished.
 */
export function Spinner({ className }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={cn(
        "inline-block size-3 shrink-0 animate-spin rounded-full border-[1.5px] border-current border-t-transparent opacity-70 motion-reduce:animate-none",
        className,
      )}
    />
  );
}
